(() => {
  if (window.GBSwitchTooltipsInitialized) return;
  window.GBSwitchTooltipsInitialized = true;

  let activeTrigger = null;
  let showTimer = 0;
  let hideTimer = 0;
  let popover = null;

  const VIEWPORT_PADDING = 16;
  const TRIGGER_GAP = 8;

  const getViewportBottom = () => {
    let bottom = window.innerHeight - VIEWPORT_PADDING;
    const minOverlayWidth = Math.min(280, window.innerWidth * 0.5);

    document.querySelectorAll('body *').forEach((element) => {
      if (element === popover || (popover && popover.contains(element))) return;

      const styles = window.getComputedStyle(element);
      if (styles.display === 'none' || styles.visibility === 'hidden' || Number(styles.opacity) === 0) return;
      if (styles.position !== 'fixed' && styles.position !== 'sticky') return;

      const rect = element.getBoundingClientRect();
      if (rect.width < minOverlayWidth || rect.height < 20 || rect.height > 180) return;
      if (rect.bottom >= window.innerHeight - 2 && rect.top > VIEWPORT_PADDING) {
        bottom = Math.min(bottom, rect.top - VIEWPORT_PADDING);
      }
    });

    return Math.max(bottom, VIEWPORT_PADDING + 120);
  };

  const getPopover = () => {
    if (popover) return popover;
    popover = document.createElement('div');
    popover.className = 'gb-switch-tooltip-popover';
    popover.setAttribute('role', 'tooltip');
    popover.addEventListener('mouseenter', () => {
      clearTimeout(hideTimer);
    });
    popover.addEventListener('mouseleave', hide);
    document.body.appendChild(popover);
    return popover;
  };

  const getTrigger = (target) => target && target.closest('[data-switch-tooltip-trigger][data-tooltip]');

  const position = () => {
    if (!activeTrigger || !popover) return;

    const triggerRect = activeTrigger.getBoundingClientRect();
    const viewportBottom = getViewportBottom();
    popover.style.left = '0px';
    popover.style.top = '0px';
    popover.style.maxWidth = `${Math.min(350, window.innerWidth - 24)}px`;
    popover.style.maxHeight = `${Math.max(120, viewportBottom - VIEWPORT_PADDING)}px`;

    requestAnimationFrame(() => {
      const popoverRect = popover.getBoundingClientRect();
      let left = triggerRect.left + triggerRect.width / 2 - popoverRect.width / 2;
      const belowTop = triggerRect.bottom + TRIGGER_GAP;
      const aboveTop = triggerRect.top - popoverRect.height - TRIGGER_GAP;
      const spaceBelow = viewportBottom - belowTop;
      const spaceAbove = triggerRect.top - VIEWPORT_PADDING - TRIGGER_GAP;
      let top = belowTop;

      left = Math.max(16, Math.min(left, window.innerWidth - popoverRect.width - 16));

      if (popoverRect.height > spaceBelow && (aboveTop >= VIEWPORT_PADDING || spaceAbove > spaceBelow)) {
        top = aboveTop;
      }

      top = Math.max(VIEWPORT_PADDING, Math.min(top, viewportBottom - popoverRect.height));

      popover.style.left = `${left + window.scrollX}px`;
      popover.style.top = `${top + window.scrollY}px`;
      popover.classList.add('is-visible');
    });
  };

  function show(trigger) {
    const tooltip = trigger.getAttribute('data-tooltip');
    if (!tooltip) return;

    activeTrigger = trigger;
    const node = getPopover();
    node.innerHTML = tooltip;
    node.classList.remove('is-visible');
    position();

    node.querySelectorAll('img').forEach((image) => {
      if (!image.complete) image.addEventListener('load', position, { once: true });
    });
    window.setTimeout(position, 250);
  }

  function scheduleShow(trigger) {
    clearTimeout(showTimer);
    clearTimeout(hideTimer);
    showTimer = setTimeout(() => show(trigger), 200);
  }

  function hide() {
    clearTimeout(showTimer);
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => {
      if (popover) popover.classList.remove('is-visible');
      activeTrigger = null;
    }, 120);
  }

  document.addEventListener('mouseover', (event) => {
    const trigger = getTrigger(event.target);
    if (!trigger || trigger.contains(event.relatedTarget)) return;
    scheduleShow(trigger);
  });

  document.addEventListener('mouseout', (event) => {
    const trigger = getTrigger(event.target);
    if (!trigger) return;
    if (trigger.contains(event.relatedTarget) || (popover && popover.contains(event.relatedTarget))) return;
    hide();
  });

  document.addEventListener('focusin', (event) => {
    const trigger = getTrigger(event.target);
    if (trigger) scheduleShow(trigger);
  });

  document.addEventListener('focusout', (event) => {
    const trigger = getTrigger(event.target);
    if (trigger) hide();
  });

  document.addEventListener('click', (event) => {
    const trigger = getTrigger(event.target);
    if (!trigger) {
      if (popover && !popover.contains(event.target)) hide();
      return;
    }

    if (activeTrigger === trigger && popover && popover.classList.contains('is-visible')) {
      hide();
      return;
    }
    show(trigger);
  });

  window.addEventListener('resize', position);
  window.addEventListener('scroll', position, true);
})();
